import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/service/user.service';
import { ContentService } from 'src/app/service/content.service';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';
import {
  LoginRequest,
  LoginResponse,
  LoginStatus,
} from '../../../shared/models/loginrequest';
import { RedirectService } from 'src/app/shared/services/redirect.service';
import {
  AuthenticateSamlTfaRequest,
  SsoRegistration,
  SsoRegistrationResult,
  SsoRequest,
} from 'src/app/shared/models/ssorequest';
import {
  ToastPopUpComponents
} from 'src/app/shared/services/toast-popup.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { SpinnerComponent } from 'src/app/component/spinner/spinner.component';
import { SsoRegistrationRequest } from 'src/app/shared/models/registration';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Title } from '@angular/platform-browser';
import { ToastOptions } from 'src/app/core/components/toast/toast.component';
import { TranslationPipe } from 'src/app/shared/pipes/translation.pipe';
import { SentenceCasePipe } from 'src/app/shared/pipes/sentence-case.pipe';

@Component({
  selector: 'app-login-page',
  providers: [TranslationPipe, SentenceCasePipe],
  template: `
    <!-- Loading state while waiting for session storage and translations -->
    <div *ngIf="!sessionStorageSet || !translationsReady" class="tw-flex tw-items-center tw-justify-center tw-min-h-screen">
      <div class="tw-text-center">
        <app-dot-loader></app-dot-loader>
        <p class="tw-mt-4 tw-text-gray-600"></p>
      </div>
    </div>
    
    <!-- Main content when both session storage and translations are ready -->
    <ng-container *ngIf="sessionStorageSet && translationsReady">
    <div class="tw-flex tw-flex-col ">
      <img
        src="assets/Images/arrows.png"
                 [attr.alt]="'Sedgwick Arrows Logo' | translation: translationRequest"
        class="tw-absolute tw-w-[11vw] tw-h-[11vw] tw-top-0 tw-right-0 tw-m-4 tw-hidden md:tw-block"
      />

      <div
        class="tw-flex-grow  tw-mt-[10vh] md:tw-mt-[20vh]  tw-items-center tw-justify-center"
      >
        <div class="tw-grid tw-place-items-center app-pb4">
          <ng-container *ngIf="clientData">
            <img
              *ngIf="
                clientData.logoContentRequest.hasClientRecord &&
                clientData.logoContentRequest.absenceOneClient &&
                clientData.logoContentRequest.dualLogo
              "
              src="data:image/JPEG;base64,{{
                clientData.logoContentRequest.absenceOneLogoImg
              }}"
              class="tw-flex tw-justify-center tw-w-[90%] md:tw-w-[20%]"
              [attr.alt]="clientData.logoContentRequest.absenceOneLogoAlt | translation: translationRequest"
              tabindex="0"
              [attr.aria-label]="
                clientData.logoContentRequest.absenceOneLogoAlt | translation: translationRequest
              "
            />
            <img
              *ngIf="
                (clientData.logoContentRequest.hasClientRecord &&
                  !clientData.logoContentRequest.absenceOneClient &&
                  clientData.logoContentRequest.dualLogo) ||
                !clientData.logoContentRequest.hasClientRecord
              "
              src="data:image/JPEG;base64,{{
                clientData.logoContentRequest.sedgwickLogoImg
              }}"
              class="tw-flex tw-justify-center tw-w-[90%] md:tw-w-[20%]"
              [attr.alt]="clientData.logoContentRequest.sedgwickLogoAlt | translation: translationRequest"
              tabindex="0"
              [attr.aria-label]="clientData.logoContentRequest.sedgwickLogoAlt | translation: translationRequest"
            />
          </ng-container>
        </div>
        <div
          class="tw-flex tw-flex-grow  tw-justify-center  tw-h-auto tw-min-h-[20vh]"
        >
          <div
            class="login-container tw-w-[90%]  md:tw-w-[45%] xl:tw-w-[30%]"
            role="main"
          >
            <form
              role="none"
              class=""
              [formGroup]="loginForm"
              (ngSubmit)="onSubmit()"
            >
              <div
                class="tw-flex tw-w-full tw-justify-center "
                [ngClass]="{
                  'tw-mt-[-45px] app-pt2': true,
                  'tw-h-full': !clientData.logoContentRequest.clientLogoImg
                }"
              >
                <div
                  role="banner"
                  class="tw-bg-[var(--sed-warm-white-color)] tw-w-[100%] tw-shadow-lg app-pb2"
                >
                  <ng-container
                    *ngIf="!clientData.logoContentRequest.clientLogoImg"
                  >
                                         <div
                       class="tw-flex tw-w-full tw-justify-center tw-items-center tw-h-full tw-pt-8 tw-pb-2"
                     >
                       <h1 class="tw-font-bold">{{ 'Login' | translation: translationRequest | sentenceCase }}</h1>
                     </div>
                  </ng-container>

                  <ng-container
                    *ngIf="clientData.logoContentRequest.clientLogoImg"
                  >
                    <div
                      class="tw-flex tw-w-full tw-justify-center tw-mt-[-45px] app-pt2"
                    >
                                             <div class="tw-p-8 tw-text-center app-pb4">
                         <h1 class="tw-font-bold">{{ 'Login' | translation: translationRequest | sentenceCase }}</h1>
                       </div>
                    </div>

                    <div
                      class="tw-flex tw-w-full tw-justify-center tw-items-center tw-h-full tw-mt-[-45px] tw-p-[5px] app-pb3"
                    >
                     <ng-container>
                        <img
                          src="data:image/JPEG;base64,{{
                            clientData.logoContentRequest.clientLogoImg
                          }}"
                          class="tw-w-full tw-h-24 tw-object-contain"
                          [attr.alt]="'ClientLogoAlt' | translationClientCustomization:clientData.logoContentRequest.clientLogoAlt"
                          tabindex="0"
                          [attr.aria-label]="'ClientLogoAlt' | translationClientCustomization:clientData.logoContentRequest.clientLogoAlt"
                        />
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="!passwordChanged && !accountUnlocked">
                <p
                  class="app-pt2"
                  *ngIf="showInvalidLoginToast && !showDisabledLoginToast"
                >
                  <app-toast
                    [message]="loginToastErrorMessage | sentenceCase"
                    [type]="toastEnumOptions.Error"
                    isToastFocus="true"
                  ></app-toast>
                </p>
                <p *ngIf="!showInvalidLoginToast && showDisabledLoginToast">
                  <app-toast
                    [message]="loginToastErrorMessage | sentenceCase"
                    [type]="toastEnumOptions.Error"
                  ></app-toast>
                </p>
              </ng-container>
              <p *ngIf="passwordChanged && isLogOut != 'Y' &&  isLogOut != 'S'">
                <app-toast
                  [message]="passwordChangeToast | translation: translationRequest | sentenceCase"
                  [type]="toastEnumOptions.Success"
                ></app-toast>
              </p>
              <p *ngIf="accountUnlocked">
                <app-toast
                  [message]="unlockAccountToast | translation: translationRequest | sentenceCase"
                  [type]="toastEnumOptions.Success"
                ></app-toast>
              </p>
              <p *ngIf="isLogOut === 'Y' || isLogOut === 'S'">
                <app-toast
                  [message]="logOutToast | translation: translationRequest"
                  [type]="toastEnumOptions.Success"
                ></app-toast>
              </p>
              <ng-container
                *ngIf="registrationMethod !== 'NONE' && isLogOut !== 'S'"
              >
                <ul role="none" class="app-mt3">
                  <li role="none" class="tw-w-full">
                    <span class="tw-pl-[12%] app-pb3">{{ 'User name' | translation: translationRequest | sentenceCase}}</span>
                  </li>
                  <li
                    role="none"
                    class="tw-w-full tw-flex tw-flex-row tw-items-center"
                  >
                    <div class="tw-w-[10%] ">
                      <mat-icon class="custom-icon">person_outline</mat-icon>
                    </div>
                    <mat-form-field
                      role="none"
                      tabindex="-1"
                      class="tw-w-[90%]"
                    >
                      <input
                        required
                        role="textbox"
                        aria-required="true"
                        [attr.aria-label]="'Enter user name max length ' + maxLength | translation: translationRequest"
                        matInput
                        #userNameFocus
                        type="text"
                        formControlName="userName"
                        name="userName"
                        autocomplete="off"
                        [maxlength]="maxLength"
                      />
                      <mat-error
                        class="error-message"
                        role="none"
                        *ngIf="
                          (loginForm.get('userName').errors ||
                            loginForm.get('userName').dirty ||
                            loginForm.get('userName').touched) &&
                          loginForm.get('userName').hasError('required')
                        "
                      >
                                                 <span>{{ 'Error : User name is required.' | translation: translationRequest }}</span>
                      </mat-error>
                    </mat-form-field>
                  </li>

                                     <li role="none" class="tw-w-full">
                     <span class="tw-pl-[12%] app-pb3">{{ 'Password' | translation: translationRequest }}</span>
                   </li>
                  <li
                    role="none"
                    class="tw-w-full tw-flex tw-flex-row tw-items-center"
                  >
                    <div class="tw-w-[10%] ">
                      <mat-icon class="custom-icon">lock_outline</mat-icon>
                    </div>

                    <mat-form-field
                      role="none"
                      tabindex="-1"
                      class="tw-w-[90%]"
                    >
                      <input
                        required
                        aria-required="true"
                        [attr.aria-label]="'Enter password max length ' + maxLength | translation: translationRequest"
                        matInput
                        #passwordFocus
                        class="input"
                        type="password"
                        formControlName="password"
                        name="password"
                        autocomplete="new-password"
                        [maxlength]="maxLength"
                        class="tw-w-[90%]"
                      />
                      <mat-error
                        class="error-message"
                        role="none"
                        *ngIf="
                          (loginForm.get('password').errors ||
                            loginForm.get('password').dirty ||
                            loginForm.get('password').touched) &&
                          loginForm.get('password').hasError('required')
                        "
                      >
                                                 <span>{{ 'Error : Password is required.' | translation: translationRequest }}</span>
                      </mat-error>
                    </mat-form-field>
                  </li>
                </ul>

                <div>
                                     <div class="tw-w-full tw-flex tw-justify-end app-pt2">
                     <a href="" routerLink="/register">{{ 'New user' | translation: translationRequest }}</a>
                   </div>
                  <div class="tw-w-full tw-flex tw-justify-end app-pt1">
                                         <a href="" routerLink="/forgotPassword"
                       >{{ 'Forgot user name or password' | translation: translationRequest }}</a
                     >
                  </div>

                </div>
              </ng-container>

              <p
                *ngIf="showLoginToast && !utility.isNullOrEmpty(loginMessage) && 'LoginMessage' | translationClientCustomization:loginMessage"
                class="app-pt2 tw-w-full tw-flex"
              >
                <app-toast
                  [message]="'LoginMessage' | translationClientCustomization:loginMessage"
                  [type]="toastEnumOptions.Info"
                ></app-toast>
              </p>
              <div>
                <div class="tw-w-full tw-flex tw-flex-row tw-items-center">
                  <mat-icon aria-hidden="true" class="mat-primary"
                    >{{ termsIcon }}
                  </mat-icon>
                    <span
                     tabindex="0"
                     class="expandCollapseHover"
                     (keyup.enter)="collapseExpand(nextAction)"
                     (click)="collapseExpand(nextAction)"
                     [attr.aria-label]="'Expandable terms of service' | translation: translationRequest"
                     role="button"
                     [attr.aria-expanded]="!doCollapse"
                   >
                     {{ 'Terms of service' | translation: translationRequest }}
                   </span>
                </div>
                <div
                  [ngClass]="{
                    'login-info': !doCollapse,
                    'login-info-hidden': doCollapse
                  }"
                  class=""
                >
                                     <span role="alert">
                     {{ 'Access to this information resource is restricted to authorized users only. This information resource may be monitored for administrative and security reasons. By proceeding, you consent to this monitoring. In order to protect the information entrusted to Sedgwick, unauthorized access and/or unauthorized use of this information resource may be prosecuted to the fullest extent of the law.' | translation: translationRequest }}
                   </span>
                </div>
              </div>

              <div class="tw-flex tw-justify-end app-pt1 ">
                                 <app-button
                   *ngIf="registrationMethod !== 'NONE' && isLogOut !== 'S'"
                   [disabled]="false"
                   emphasis="High"
                   type="submit"
                   class=""
                 >
                   {{ 'Login' | translation: translationRequest }}
                 </app-button>
                                 <app-button
                   *ngIf="
                     registrationMethod === 'NONE' &&
                     !utility.isNullOrEmpty(redirectUrl)
                   "
                   [disabled]="false"
                   emphasis="High"
                   (click)="redirectToUrl()"
                   type="button"
                   class=""
                 >
                   {{ 'Login' | translation: translationRequest }}
                 </app-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="tw-mt-auto">
        <div class="tw-flex tw-items-center tw-justify-center tw-p-4">
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  </ng-container> `,
  styles: [
    `
      .banner {
        background-color: var(--sed-open-grey-color);
      }
      .custom-icon {
        transform: scale(1.2);
        margin-right: 8px;
      }

      .logo {
        max-height: 100%;
        height: auto;
        width: auto;
        padding: 5%;
      }
      .login-container {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
          0 6px 20px 0 rgba(0, 0, 0, 0.19);
        padding: 20px;
        background-color: var(--sed-warm-white-color);
      }

      .login-info {
        height: auto;
        width: 100%;
        padding-top: 20px;
        padding-left: 15px;
        padding-right: 7px;
        padding-bottom: 10px;
        text-align: justify;
      }
      .login-info-hidden {
        display: none;
        height: 0px;
        max-height: 0px;
        width: 90%;
        padding-top: 20px;
        padding-left: 15px;
        padding-right: 20px;
        padding-bottom: 40px;
      }

      .expandCollapseHover {
        cursor: pointer;
      }
    `,
  ],
})
export class LoginPageComponent implements OnInit, OnDestroy {
  isLogOut: string = this.activatedRoute.snapshot.queryParams['islogout'];

  vanitypath: string = this.utility.isNullOrEmpty(
    this.activatedRoute.snapshot.paramMap.get('vanitypath')
  )
    ? this.activatedRoute.snapshot.queryParams['clientid']
    : this.activatedRoute.snapshot.paramMap.get('vanitypath');

  clientData: any;
  loginForm = new UntypedFormGroup(
    {
      userName: new UntypedFormControl(''),
      password: new UntypedFormControl(''),
    }
    // {updateOn: 'submit'}
  );
  loginToastErrorMessage: string;
  loginRequest: LoginRequest;
  ssoRequest: SsoRequest;
  showInvalidLoginToast: boolean;
  showDisabledLoginToast: boolean;
  toastEnumOptions = ToastOptions;
  submitClicked: boolean;
  doCollapse: boolean;
  termsIcon: string;
  nextAction: string;
  passwordChanged: boolean;
  passwordChangeToast =
    'Password successfully changed. Please login with your new password.';
  unlockAccountToast = 'Account unlocked.';
  logOutToast =  this.sentenceCasePipe.transform('You have successfully logged out of your session.');
  accountUnlocked: boolean;
  accountDisabled: boolean;
  sessionStorageSet: boolean;
  translationsReady: boolean = false;
  private translationSubscription: Subscription;
  toastPopupOptions = ToastPopUpComponents;
  sourceURL: string;
  maxLength = 50;
  loginMessage: string;
  showLoginToast: boolean;
  showReportClaim: boolean;
  redirectUrl: string;
  registrationMethod: string;
  logoaltLabel: string;
  translations: Map<string, string> = new Map();
  translationRequest: TranslationRequest = new TranslationRequest(
    {
      language:sessionStorage.getItem('languagepreference'), // Default to English, you can make this dynamic
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'LoginApp',
      subGroup: 'LoginApp'
    }
  );
  @ViewChild('userNameFocus') userNameFocus: ElementRef;
  @ViewChild('passwordFocus') passwordFocus: ElementRef;

  constructor(
    private userService: UserService,
    private contentService: ContentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private redirectService: RedirectService,
    public utility: UtilityService,
    private el: ElementRef,
    private spinnerComponent: SpinnerComponent,
    private announcer: LiveAnnouncer,
    private titleService: Title,
    public translationService: TranslationService,
    private translatePipe: TranslationPipe,
    private sentenceCasePipe:SentenceCasePipe
  ) {}

  get userName() {
    return this.loginForm.get('userName');
  }

  get password() {
    return this.loginForm.get('password');
  }

  async ngOnInit(): Promise<void> {
    const logOutLanguage =  this.activatedRoute.snapshot.queryParams['language'];

     if (logOutLanguage) {
    sessionStorage.setItem("languagepreference", logOutLanguage);
    this.translationService.setDefaultLanguage(logOutLanguage);
    } 
    this.sourceURL = window.location.href;
    const url = !this.utility.isNullOrEmpty(
      this.sourceURL.substring(0, this.sourceURL.indexOf('&islogout'))
    )
      ? this.sourceURL.substring(0, this.sourceURL.indexOf('&islogout'))
      : this.sourceURL;
    this.sourceURL = url;
    this.userService.mySedgwickUrl = this.sourceURL;

    this.handleVovSso();

    this.setInitialToast();
    if (this.accountDisabled) this.showDisabledToast();

    this.vanitypath = this.vanitypath == null ? '' : this.vanitypath;
    this.clientData = JSON.parse(sessionStorage.getItem('clientData'));
        // Get user's browser language setting
    // note this will be changed by user's language preference from dropdown
    this.titleService.setTitle(this.translatePipe.transform('mySedgwick - Login', this.translationRequest));

    if (
      this.clientData == null ||
      (this.vanitypath == '' && this.clientData?.vanityPath == null) ||
      (this.vanitypath != '' && this.clientData?.vanityPath != this.vanitypath)
    ) {
      this.contentService.GetVanityDetails(this.vanitypath).subscribe(
        async (data) => {
          sessionStorage.setItem('clientData', JSON.stringify(data));
          this.clientData = JSON.parse(sessionStorage.getItem('clientData'));
          await this.loadTranslations();
          this.sessionStorageSet = true;
          this.setCustomLoginPage(this.clientData);
        },
        (error) => {}
      );
    } else {
      await this.loadTranslations();
      this.setCustomLoginPage(this.clientData);
      this.sessionStorageSet = true;
    }

    this.doCollapse = true;
    this.termsIcon = 'arrow_right';
  }

  async loadTranslations(): Promise<void> {
    this.translationRequest.contNum = this.clientData && this.clientData.contNum != null && this.clientData.contNum != '' && this.clientData.contNum != 0 ? this.clientData.contNum : '0';
    
     if(!this.translationService.isMultiLanagueFeatureEnabled()){
            this.translationService.setDefaultLanguage(this.translationService.getDefaultLangauge());
    }
     this.translationRequest.language = this.translationService.getDefaultLangauge();
   
    // Subscribe to translations observable to know when they're ready
    this.translationSubscription = this.translationService.translations$.subscribe(translations => {
      if ((translations && translations.size > 0) || !this.translationService.isLanguagePreferenceSet()) {
        this.translationsReady = true;
      }
    });
    this.translationRequest.language = sessionStorage.getItem('languagepreference');
    this.translationService.getTranslation(this.translationRequest);
  }

  ngOnDestroy(): void {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  onSubmit() {
    this.addValidatorsOnSubmit();
    this.hideInitialToasts();
    this.submitClicked = true;

    this.announcer.announce(
      `${this.translatePipe.transform('Login into', this.translationRequest)} ${this.loginForm.value.userName} ${this.translatePipe.transform('account', this.translationRequest)}`,
      'polite'
    );

    if (this.loginForm.invalid) return;
    this.loginRequest = new LoginRequest({
      UserName: this.loginForm.value.userName,
      Password: this.loginForm.value.password,
      TwoFactorDeviceId: '',
      SetTFADevice: false,
      ClientID: '',
      InternalAuditorContract: 0,
      SourceURL: this.sourceURL,
      Resolution: `${window.screen.width}x${window.screen.height}`,
      LanguageCode: sessionStorage.getItem('languagepreference'),
    });
    const form = this.loginForm;

    this.userService.login(this.loginRequest).subscribe(
      (result) => {
        switch (result.status) {
          case LoginStatus.Invalid:
            this.translationService.getTranslationForKey$('The system could not validate your information. Make sure your User name and Password are correct and try again.', this.translationRequest).subscribe((message) => {
              this.loginToastErrorMessage = message;
            });
            this.showInvalidLoginToast = true;
            this.showDisabledLoginToast = false;
            break;
          case LoginStatus.Disabled:
            this.showDisabledToast();
            break;
          case LoginStatus.DeadClient:
            this.translationService.getTranslationForKey$('You do not have permission to access mySedgwick.', this.translationRequest).subscribe((message) => {
              this.loginToastErrorMessage = message;
            });
            this.showInvalidLoginToast = true;
            this.showDisabledLoginToast = false;
            break;
          case LoginStatus.ClientNotSetupYet:
            this.translationService.getTranslationForKey$('You do not have permission to access mySedgwick.', this.translationRequest).subscribe((message) => {
              this.loginToastErrorMessage = message;
            });
            this.showInvalidLoginToast = true;
            this.showDisabledLoginToast = false;
            break;
          case LoginStatus.NotActiveClient:
            this.translationService.getTranslationForKey$('You do not have permission to access mySedgwick.', this.translationRequest).subscribe((message) => {
              this.loginToastErrorMessage = message;
            });
            this.showInvalidLoginToast = true;
            this.showDisabledLoginToast = false;
            break;
          case LoginStatus.InvalidContactInfo:
            this.translationService.getTranslationForKey$('We are unable to complete your login. Please contact your examiner to verify your information or to provide your email address and phone number.', this.translationRequest).subscribe((message) => {
              this.loginToastErrorMessage = message;
            });
            this.showInvalidLoginToast = true;
            this.showDisabledLoginToast = false;
            break;
          case LoginStatus.AccountLocked:
            this.userService.username = result.username;
            this.userService.saveState();
            this.router.navigate(['forgotPassword']);
            break;
          case LoginStatus.PasswordExpired:
            this.userService.username = result.username;
            this.userService.passwordExpired = true;
            this.userService.forgotPasswordToken = result.token;
            this.userService.UserContext = result.userContext;
            this.userService.saveState();
            this.router.navigate(['changePassword']);
            break;
          case LoginStatus.TwoFactorPreferences:
          case LoginStatus.TfaRequired:
            this.showInvalidLoginToast = false;
            this.userService.emailAddress = result.emailAddress;
            this.userService.phoneNumber = result.phone;
            this.userService.username = result.username;
            this.userService.sessionid = result.sessionId;
            this.userService.redirectToken = result.token;
            this.userService.mySedgwickUrl = result.mySedgwickUrl;
            this.userService.sourceUrl = result.sourceUrl;
            this.userService.loginSubStatus = result.loginSubStatus;
            this.userService.UserContext = result.userContext;
            this.userService.saveState();
            this.router.navigate(['multiFactorAuthentication']);
            break;
          case LoginStatus.Success:
            this.userService.UserContext = result.userContext;
            this.redirectService.redirectToMySedgwick(
              new SsoRequest({
                UserName: result.username,
                SessionId: result.sessionId,
                Token: result.token,
                MySedgwickUrl: result.mySedgwickUrl,
                ClientType: result.userContext.clientType,
                SourceUrl: result.sourceUrl,
              })
            );
            break;
        }
        if (this.loginToastErrorMessage != null) {
          this.sentenceCasePipe.transform(this.loginToastErrorMessage);
          this.announcer.announce(this.loginToastErrorMessage, 'polite');
        }
      },
      (e) => {
        this.translationService.getTranslationForKey$('The system could not validate your information. Make sure your User name and Password are correct and try again.', this.translationRequest).subscribe((message) => {
          this.loginToastErrorMessage = message;
          this.sentenceCasePipe.transform(this.loginToastErrorMessage);
        });
        this.showInvalidLoginToast = true;
        this.showDisabledLoginToast = false;

        let response = JSON.parse(e.response);
        if (response.status === 400) {
          let errors = response.errors[_.upperFirst('userName')];
          if (errors) {
            form.get('userName').setErrors({
              server: {
                message: errors[0],
              },
            });
          }
        }
        console.error(response);
      }
    );
    this.loginForm.controls['userName'].markAsTouched();
    this.loginForm.controls['password'].markAsTouched();
  }

  addValidatorsOnSubmit(): void {
    this.userName.setValidators([Validators.required]);
    if (this.userName.invalid) {
      this.userNameFocus.nativeElement.focus();
      return;
    }
    this.userName.updateValueAndValidity();

    this.password.setValidators([Validators.required]);
    if (this.password.invalid) {
      this.passwordFocus.nativeElement.focus();
      return;
    }
    this.password.updateValueAndValidity();
  }

  collapseExpand(action: string): void {
    if (action == 'collapse') {
      this.termsIcon = 'arrow_right';
      this.doCollapse = true;
      this.nextAction = 'expand';
    } else {
      this.termsIcon = 'arrow_drop_down';
      this.doCollapse = false;
      this.nextAction = 'collapse';
    }
  }

  setInitialToast(): void {
    this.passwordChanged = this.userService.passwordChanged;
    this.accountUnlocked = this.userService.accountUnlocked;
    this.accountDisabled = this.userService.accountDisabled;
  }

  hideInitialToasts(): void {
    this.passwordChanged = false;
    this.accountUnlocked = false;
  }

  showDisabledToast(): void {
    this.translationService.getTranslationForKey$('Your mySedgwick login has been disabled due to excessive reset attempts. If you have any questions please contact ', this.translationRequest).subscribe((message1) => {
      this.translationService.getTranslationForKey$('Sedgwick Support', this.translationRequest).subscribe((supportText) => {
        this.loginToastErrorMessage = message1 + `<span tabindex='0' class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}>${supportText}</span>.`;
      });
    });
    this.showDisabledLoginToast = true;
    this.showInvalidLoginToast = false;
  }

  setCustomLoginPage(clientData: any): void {
    this.redirectUrl = clientData.redirectUrl ?? clientData.reportClaimRedirect;
    this.registrationMethod = clientData.registrationMethod;
    this.setClientSpecificRedirect(clientData.loginType, this.redirectUrl);
    this.setLoginMessage(clientData);
  }

  setClientSpecificRedirect(loginType: string, redirectUrl: string): void {
    if (
      loginType == 'LOGIN_INTAKE' &&
      !this.utility.isNullOrEmpty(redirectUrl)
    ) {
      this.showReportClaim = true;
    }

    if (loginType == 'INTAKE' && !this.utility.isNullOrEmpty(redirectUrl)) {
      this.redirectToUrl();
    }
  }

  setLoginMessage(clientData: any): void {
    //Might need to add more logic around removing html from toast and what not. If that isnt needed then this can be simplified
    if (
      clientData.loginType == 'LOGIN' ||
      clientData.loginType == 'LOGIN_INTAKE' ||
      this.registrationMethod == 'NONE'
    ) {
      this.showLoginToast = true;
      this.loginMessage = clientData.loginMessage;
    }
  }

  redirectToUrl(): void {
    window.location.href = this.redirectUrl;
  }

  navigateToSsoTfa(results: LoginResponse): void {
    this.userService.emailAddress = results.emailAddress;
    this.userService.phoneNumber = results.phone;
    this.userService.username = results.username;
    this.userService.ssoRegistration = true;
    this.router.navigate(['multiFactorAuthentication']);
  }

  redirectTfaForVovSso(result: SsoRegistrationResult): void {
    this.spinnerComponent.spinnerAction(true);
    let authSamlRequest = new AuthenticateSamlTfaRequest({
      Username: result.username,
      SessionId: result.sessionId,
    });

    this.userService
      .authenticateSsoUserForTfa(authSamlRequest)
      .subscribe((results) => {
        let ssoAuthentication = new SsoRegistration({
          loginResponse: results,
        });

        if (
          ssoAuthentication.loginResponse.status == LoginStatus.PasswordExpired
        )
          this.router.navigate(['sso'], { queryParams: { status: '301' } });
        else {
          this.userService
            .createSsoTwoFactorRequest(ssoAuthentication)
            .subscribe((data) => {
              if (data) {
                this.navigateToSsoTfa(results);
              }
            });
        }
      });
  }

  redirectToRegistrationForVovSso(data: SsoRegistrationResult): void {
    let registrationData = new SsoRegistrationRequest({
      DoSsoRegistration: data.ssoRegistration,
      ForceTfa: data.forceTfa == 'Yes',
      ClientCode: data.clientCode,
      SessionId: data.sessionId,
      TextPhone: data.textPhone,
      UserEmail: data.userEmail,
      Username: data.username,
    });

    this.userService.ssoRegistrationRequest = registrationData;

    this.router.navigate(['register']);
  }

  handleVovSso(): void {
    this.userService.ssoRegister().subscribe((data) => {
      if (data != null && data.isSuccessful) {
        this.userService.redirectToken = data.token;
        this.userService.mySedgwickUrl = data.mySedgwickUrl;
        if (data.forceTfa == 'Yes' && data.ssoRegistration)
          this.redirectTfaForVovSso(data);
        else this.redirectToRegistrationForVovSso(data);
      }
    });
  }
}